<template>
  <div>
    <div
      v-if="organizace.testovaciRozhrani"
      class="bg-danger text-white text-center p-1"
    >
      {{ $t("portal.testing-process") }}
    </div>
    <div v-if="isAuthenticationGranted==false">
        <b-row class="align-items-center">
            <b-col>
                <b-row>
                    <router-link :to="'/' + $customerUuid + '/'" style="text-decoration: none;">
                        <h1 class="header_title">{{ organizace.nazevObce }}</h1>
                    </router-link>
                </b-row>
                <b-row>
                    <h2 class="header_title">{{ $t("portal.title") }}</h2>
                </b-row>
            </b-col>
            <b-col>
              <div class="d-flex justify-content-end flex-shrink-1">
                  <LoginControl />
                </div>
            </b-col>
        </b-row>
    </div>

    <div v-if="isAuthenticationGranted">
        <b-row class="align-items-center">
          <b-col>
              <b-row>
                  <router-link :to="'/' + $customerUuid + '/'" style="text-decoration: none;">
                      <h1 class="header_title">{{ organizace.nazevObce }}</h1>
                  </router-link>
              </b-row>
              <b-row>
                  <h2 class="header_title">{{ $t("portal.title") }}</h2>
              </b-row>
          </b-col>
          <b-col >
            <div class="d-flex justify-content-end flex-shrink-1">
                  <b-row>
                      <b-col>
                        <UserControlNia />
                      </b-col>
                      <b-col>
                        <LogoutControl />
                      </b-col>
                  </b-row>
            </div>
          </b-col>
        </b-row>
    </div>
  </div>
</template>

<script>
import LoginControl from "../components/LoginControl";
import CartControl from "../components/CartControl";
import UserControlNia from "../components/UserControlNia";
import LogoutControl from "../components/LogoutControl.vue";
import { mapState } from "vuex";
import { eventBus } from "../main";

export default {
  components: {
    LoginControl,
    CartControl,
    UserControlNia,
    LogoutControl,
  },
  computed: mapState(["organizace"]),
  data() {
    return {
      isAuthenticationGranted: null,
    };
  },
  mounted() {
    this.refreshAuthenticationStatus();

    // Listen for authentication change events
    eventBus.$on('auth-changed', () => {
      this.refreshAuthenticationStatus();
    });
  },
  methods: {
    refreshAuthenticationStatus() {
      this.$backend.getAuthenticationStatus(response => {
        this.isAuthenticationGranted = this.$utils.isAuthenticationGranted(response);
      });
    }
  },
};
</script>
